"use client";

import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import styles from "./ProductSpecialOffersAccordion.module.scss";
import { cleanHtml } from "../../../../utils/string/cleanHtml";
import { Message } from "../../../../types/types";

type Props = {
  specialOffers: Message[];
  productType: string;
  open?: boolean;
};

export const PRODUCT_SPECIAL_OFFERS_ACCORDION_INSTANCE_NAME = "special-offers";

export function ProductSpecialOffersAccordionUI({
  specialOffers,
  productType,
  open,
}: Props) {
  if (productType === "RetiredStaticBundle") return null;
  if (specialOffers.length == 0) return null;

  return (
    <Accordion
      id="accordion-special-offers"
      className={styles["product-accordion__item"]}
      data-testid="accordion:special-offers"
      label={`Special offer${specialOffers.length > 1 ? "s" : ""}`}
      animated={true}
      instanceName={PRODUCT_SPECIAL_OFFERS_ACCORDION_INSTANCE_NAME}
      responsive
      open={open}
    >
      <div
        data-testid="product:special-offers:list"
        className={styles.productSpecialOffersList}
      >
        {specialOffers.map((offer) => (
          <div
            key={offer.title}
            className={styles.listItem}
            dangerouslySetInnerHTML={{
              __html: cleanHtml(offer.description) || "",
            }}
            data-testid="product:special-offers:item"
          />
        ))}
      </div>
    </Accordion>
  );
}
